import { useEffect, useState } from 'react';

/** Time left to `iso`, ticking each second and resyncing when the tab returns. */
export function useDeadline(iso: string | null): { msLeft: number | null; expired: boolean } {
  const target = iso ? Date.parse(iso) : null;
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (target === null) return;
    const tick = () => setNow(Date.now());
    tick();
    const id = window.setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
    return () => {
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [target]);
  if (target === null || Number.isNaN(target)) return { msLeft: null, expired: false };
  const msLeft = Math.max(0, target - now);
  return { msLeft, expired: msLeft === 0 };
}
